import { render } from "./relocation_confirm_dialog.vue?vue&type=template&id=62694fef"
import script from "./relocation_confirm_dialog.vue?vue&type=script&lang=js"
export * from "./relocation_confirm_dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__